export var PHONE_NUMBER_PLACEHOLDER = '+1';